// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxValidatorController from "./checkbox_validator_controller"
application.register("checkbox-validator", CheckboxValidatorController)

import CheckboxWarningController from "./checkbox_warning_controller"
application.register("checkbox-warning", CheckboxWarningController)

import CurrencyValidatorController from "./currency_validator_controller"
application.register("currency-validator", CurrencyValidatorController)

import DirtyTableObserverController from "./dirty_table_observer_controller"
application.register("dirty-table-observer", DirtyTableObserverController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import EmailValidatorController from "./email_validator_controller"
application.register("email-validator", EmailValidatorController)

import EquityAssetsTableController from "./equity_assets_table_controller"
application.register("equity-assets-table", EquityAssetsTableController)

import FieldDescriptionController from "./field_description_controller"
application.register("field-description", FieldDescriptionController)

import FormStepsController from "./form_steps_controller"
application.register("form-steps", FormStepsController)

import GermanPostcodeValidatorController from "./german_postcode_validator_controller"
application.register("german-postcode-validator", GermanPostcodeValidatorController)

import IbanValidatorController from "./iban_validator_controller"
application.register("iban-validator", IbanValidatorController)

import GermanIbanValidatorController from "./german_iban_validator_controller"
application.register("german-iban-validator", GermanIbanValidatorController)

import LoanApplicationForm1Controller from "./loan_application_form_1_controller"
application.register("loan-application-form-1", LoanApplicationForm1Controller)

import LoanApplicationForm3Controller from "./loan_application_form_3_controller"
application.register("loan-application-form-3", LoanApplicationForm3Controller)

import LoanApplicationFormSelfDisclosureHouseholdController from "./loan_application_form_self_disclosure_household_controller"
application.register("loan-application-form-self-disclosure-household", LoanApplicationFormSelfDisclosureHouseholdController)

import LoanInfoboxController from "./loan_infobox_controller"
application.register("loan-infobox", LoanInfoboxController)

import LoanTableController from "./loan_table_controller"
application.register("loan-table", LoanTableController)

import OnlyIntegerInputController from "./only_integer_input_controller"
application.register("only-integer-input", OnlyIntegerInputController)

import PlacekitAddressController from "./placekit_address_controller"
application.register("placekit-address", PlacekitAddressController)

import PresenceValidatorController from "./presence_validator_controller"
application.register("presence-validator", PresenceValidatorController)

import PrivateDebtsTableController from "./private_debts_table_controller"
application.register("private-debts-table", PrivateDebtsTableController)

import RealEstateAssetsTableController from "./real_estate_assets_table_controller"
application.register("real-estate-assets-table", RealEstateAssetsTableController)

import RealEstateDebtsTableController from "./real_estate_debts_table_controller"
application.register("real-estate-debts-table", RealEstateDebtsTableController)

import SmartSignUpController from "./smart_sign_up_controller"
application.register("smart-sign-up", SmartSignUpController)

import SubmitLoadingSpinnerController from "./submit_loading_spinner_controller"
application.register("submit-loading-spinner", SubmitLoadingSpinnerController)

import TruncateController from "./truncate_controller"
application.register("truncate", TruncateController)
